export default "__VITE_ASSET__CGkqkD$a__"